import {useObserver} from 'mobx-react';
import * as React from 'react';
import {useEffect} from 'react';
import {useCardsPerDayQuery, useGetAllowedCoursesQuery} from "../../../types.d";
import {WorkspaceStore} from "../../../stores/WorkspaceStore";
import {container} from "@intelingu/core/IoC/container";
import {Link} from "react-router-dom";
import {AdminPage} from "../admin/AdminPage";
import {DashboardContent} from "./DashboardContent";
import {getShortRoleByUser} from "../../../utils/getShortRoleByUser";

export function IndexPage(props) {
    const allowedCourses = useGetAllowedCoursesQuery({
        fetchPolicy: 'network-only'
    });
    const workspace = container.get(WorkspaceStore);
    const user = workspace.user;

    useEffect(() => {
        if (!workspace.courseId && allowedCourses.data) {
            workspace.courseId = allowedCourses.data.allowedCourses[0].id
        }
    });

    if (!user) {
        return null;
    }

    const role = getShortRoleByUser(user.roles);

    if (user.roles.includes('administrator')) {
        return <AdminPage />
    }

    return useObserver(() => (
        <div className={'index-wrapper'}>
            <div className={'index-page'}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <DashboardContent />

                    <Link
                        to={`/creation/next/${workspace.courseId}/${role}`}
                        className={'btn btn-outline-primary btn-lg'}
                    >
                        Let me create something great
                    </Link>
                </div>
            </div>
        </div>
    ));
}
